export default __webpack_public_path__ + "static/media/soccerBall.fce0c2de.svg";